module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/home-2ede597861bc518a34567e86accc8fe5.webp";